export default{
    unit:'Unit',
    unitTitle: 'Title',
    unitStatus: 'Status',
    units:'Units',
    editUnit:'Edit Unit',
    addUnit:'Add Unit',
    section :'Search By Section',


}